/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterStatScheduleDto } from '../../models/center-stat-schedule-dto';

export interface CenterStatControllerGetScheduleStat$Params {
  startAt: string;
  endAt: string;
  centerId: string;
}

export function centerStatControllerGetScheduleStat(http: HttpClient, rootUrl: string, params: CenterStatControllerGetScheduleStat$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterStatScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, centerStatControllerGetScheduleStat.PATH, 'get');
  if (params) {
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterStatScheduleDto>;
    })
  );
}

centerStatControllerGetScheduleStat.PATH = '/api/center-stat/schedule';
